import React, { useState } from 'react';
import { createLeads } from '../api/api';  // Import the API function
import '../assets/styles/LetsTalk.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    phone: '',
  });

  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);  // New state variable for form submission

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);  // Disable submit button
    setError(null);
    try {
      const data = await createLeads(formData);  // Use the API function
      setResponse("Your enquiry has been submitted, our representative will get in touch with you ASAP.");
      setFormData({ name: '', email: '', message: '', phone: '' });  // Clear form data
    } catch (error) {
      setError(error.message);
      console.error('Submission Error:', error.message);
    } finally {
      setIsSubmitting(false);  // Enable submit button
    }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name<span className="required">*</span></label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            disabled={isSubmitting}  // Disable input while submitting
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email <span className="required">*</span></label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            disabled={isSubmitting}  // Disable input while submitting
          />
        </div>
        <div className="form-group">
          <label htmlFor="phone">Phone Number</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            disabled={isSubmitting}  // Disable input while submitting
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message<span className="required">*</span></label>
          <textarea
            id="message"
            name="message"
            rows="4"
            value={formData.message}
            onChange={handleChange}
            required
            disabled={isSubmitting}  // Disable input while submitting
          ></textarea>
        </div>
       {/* <div className="form-group">
          <label htmlFor="captcha">Captcha</label>
           Add your Captcha component here 
        </div>*/}
        <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
          {isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </form>

      {response && (
        <div>
          <h3>Success</h3>
          <p>{response}</p>
        </div>
      )}

      {error && (
        <div>
          <h3>Error:</h3>
          <p>{error}</p>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
